import { z } from 'zod';

const AUTHENTICATED_CLIENT_ID_KEY = 'msalAuthenticatedClientId';
const LEGACY_AUTHENTICATED_CLIENT_ID_KEY = 'msalClientId';
const PENDING_TENANT_CLIENT_ID_KEY = 'fjuelPendingTenantClientId';
const LEGACY_PENDING_TENANT_CLIENT_ID_KEY = 'msalPendingLoginClientId';
const LOGOUT_HANDOFF_KEY = 'fjuelLogoutHandoff';
const REDIRECT_CLIENT_ID_KEY = 'fjuelRedirectClientId';
const clientIdSchema = z.string().uuid();

export const isValidClientId = (clientId: string): boolean => clientIdSchema.safeParse(clientId).success;

export const getStoredClientId = (): string | null => {
  const clientId =
    localStorage.getItem(AUTHENTICATED_CLIENT_ID_KEY) ?? localStorage.getItem(LEGACY_AUTHENTICATED_CLIENT_ID_KEY);

  if (!clientId || !isValidClientId(clientId)) {
    return null;
  }

  if (!localStorage.getItem(AUTHENTICATED_CLIENT_ID_KEY)) {
    localStorage.setItem(AUTHENTICATED_CLIENT_ID_KEY, clientId);
  }

  return clientId;
};

export const storeClientId = (clientId: string): void => {
  localStorage.setItem(AUTHENTICATED_CLIENT_ID_KEY, clientId);
};

export const clearStoredClientId = (): void => {
  localStorage.removeItem(AUTHENTICATED_CLIENT_ID_KEY);
  localStorage.removeItem(LEGACY_AUTHENTICATED_CLIENT_ID_KEY);
};

export const getPendingTenantClientId = (): string | null =>
  localStorage.getItem(PENDING_TENANT_CLIENT_ID_KEY) ?? localStorage.getItem(LEGACY_PENDING_TENANT_CLIENT_ID_KEY);

export const storePendingTenantClientId = (clientId: string): void => {
  localStorage.setItem(PENDING_TENANT_CLIENT_ID_KEY, clientId);
};

export const markLogoutHandoff = (): void => {
  localStorage.setItem(LOGOUT_HANDOFF_KEY, 'true');
};

export const clearPendingTenantClientId = (): void => {
  localStorage.removeItem(PENDING_TENANT_CLIENT_ID_KEY);
  localStorage.removeItem(LEGACY_PENDING_TENANT_CLIENT_ID_KEY);
  localStorage.removeItem(LOGOUT_HANDOFF_KEY);
};

export const getLogoutHandoffClientId = (): string | null =>
  localStorage.getItem(LOGOUT_HANDOFF_KEY) === 'true' ? getPendingTenantClientId() : null;

export const getRedirectClientId = (): string | null => {
  const clientId = sessionStorage.getItem(REDIRECT_CLIENT_ID_KEY);
  return clientId && isValidClientId(clientId) ? clientId : null;
};

export const storeRedirectClientId = (clientId: string): void => {
  if (!isValidClientId(clientId)) {
    throw new Error('Invalid authentication client ID');
  }
  sessionStorage.setItem(REDIRECT_CLIENT_ID_KEY, clientId);
};

export const clearRedirectClientId = (): void => sessionStorage.removeItem(REDIRECT_CLIENT_ID_KEY);
